export default __webpack_public_path__ + "images/Edge1002.png";